import { render, staticRenderFns } from "./ParentAddress.vue?vue&type=template&id=c262fbfc&scoped=true"
import script from "./ParentAddress.vue?vue&type=script&lang=js"
export * from "./ParentAddress.vue?vue&type=script&lang=js"
import style0 from "./ParentAddress.vue?vue&type=style&index=0&id=c262fbfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c262fbfc",
  null
  
)

export default component.exports